import React from 'react';

const PageHero = ({ title, subtitle, backgroundImage, darkImage, bgPosition }) => (
  <div
    className={`page-hero${darkImage ? ' page-hero--dark' : ''}`}
    style={{ backgroundImage: `url(${backgroundImage})`, ...(bgPosition ? { backgroundPosition: bgPosition } : {}) }}
  >
    <div className="page-hero-overlay" />
    <div className="relative z-10 text-center px-4">
      <h1 className="text-3xl md:text-5xl font-bold text-white mb-2" style={{ textShadow: '0 2px 8px rgba(0,0,0,0.5)' }}>{title}</h1>
      {subtitle && (
        <p className="text-white/90 text-lg max-w-xl mx-auto" style={{ textShadow: '0 1px 4px rgba(0,0,0,0.5)' }}>{subtitle}</p>
      )}
    </div>
  </div>
);

export default PageHero;
